<template>
  <div id="app">
    <Header v-if="showHeader" />
    <router-view />
  </div>
</template>

<script>
import store from './store'
import {getptip} from './api/signUp.js'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header
  },
  data() {
    return {
      
    }
  },
  computed: {
    showHeader() {
      // 不显示头部的页面路由名称
      const noHeaderRoutes = ['login', 'register']
      return !noHeaderRoutes.includes(this.$route.name)
    }
  },
  mounted() {
    // this.getTip()
  },
  methods: {
    getTip() {
      console.log('开始调用接口')
      getptip().then(res => {
        console.log('接口响应:', res)
        const data = res.data;
        // 将数据存储到 store 的 hintText 模块
        store.commit('hintText/SET_HINTTEXT', data);
      }).catch(error => {
        console.error('接口调用失败:', error)
      });
    },
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
}
@import "./style/sass/index.scss";
</style>
